enum EPageTab {
  BUSINESS_INFO = 'businessInfo',
  SUPPORT_DETAILS = 'supportDetails',
  ACCOUNT_FOR_PAYOUTS = 'accountForPayouts',
  TAX_CALCULATION = 'taxCalculation',
  SUMMARY = 'summary',
}

export default EPageTab;
